import * as S from './progress-bar.styled'
import { ProgressBarProps } from './progress-bar.types'

export const ProgressBar = ({
  color = 'blue',
  label,
  max = 100,
  size = 'small',
  value,
  width = '100%',
  ...rest
}: ProgressBarProps) => {
  const clamped = Math.min(Math.max(value, 0), max)
  const percent = max > 0 ? (clamped / max) * 100 : 0

  return (
    <S.Track
      {...rest}
      $color={color}
      $size={size}
      $width={width}
      aria-label={label}
      aria-valuemax={max}
      aria-valuemin={0}
      aria-valuenow={clamped}
      role="progressbar"
    >
      <S.Bar $percent={percent} />
    </S.Track>
  )
}
